export const GENDER_OPTIONS = ["Male", "Female", "Other"] as const;

export type Gender = (typeof GENDER_OPTIONS)[number];
